import { ScreenLayout } from '../../../components/index';
import { HealthOverview } from '../../../domains/integrationsHealth/HealthOverview';

export function IntegrationsHealth() {
  // As abas (Órgãos externos / Parceiros) vivem dentro do HealthOverview, que
  // compartilha a mesma consulta, o auto-refresh e o drawer de logs entre elas.
  return (
    <ScreenLayout title="Saúde das integrações">
      <HealthOverview />
    </ScreenLayout>
  );
}
